module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.account.nickname
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.isActive(),
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.getStatusLabel(_vm.account.active))))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md img-account"
  }, [(_vm.account.logo) ? _c('img', {
    attrs: {
      "src": _vm.account.logo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.account.logo) ? _c('i', {
    staticClass: "icon-image2 no-photo"
  }) : _vm._e()])])]), _vm._v(" "), _c('footer', {
    staticClass: "c-card__footer u-textLeft l-level"
  }, [_c('button', {
    staticClass: "btn btn--smart btn--sm btn--info l-level__left",
    on: {
      "click": _vm.editAction
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('edit.label')) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "header-right btn btn--smart btn--sm btn--danger l-level__right",
    attrs: {
      "slot": "header-actions"
    },
    on: {
      "click": function($event) {
        _vm.modalDeleteAccountFlag = true
      }
    },
    slot: "header-actions"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('delete.label')) + "\n    ")])]), _vm._v(" "), _c('modal-delete-account', {
    on: {
      "confirm": _vm.deleteAccount
    },
    model: {
      value: (_vm.modalDeleteAccountFlag),
      callback: function($$v) {
        _vm.modalDeleteAccountFlag = $$v
      },
      expression: "modalDeleteAccountFlag"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd059c46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/Account.vue
// module id = 3412
// module chunks = 0